const { bulkSnapshotsFromCsv } = require('./shipment-bulk-snapshot-from-allocation-sheet')
const createBulkUpsertBatchDetails = require('../batch/upsert-batch-details')
const docIdToShipmentId = require('../../lib/shipment/tools/to-shipment-id')
const get = require('lodash/get')
const flatten = require('lodash/flatten')

const PROGRAMS_NEEDING_TMS_AUTO_ROUTER = [
  'program:rwanda-rms'
]

module.exports = shipmentUpload

async function shipmentUpload (state, {
  funderShipments,
  routes,
  crypto,
  routesApi,
  shipmentApi
}) {
  await routesApi.create({ routeData: routes })

  // Save the sheet's batch details (expiry) so package/delivery notes can show them
  const bulkUpsertBatchDetails = createBulkUpsertBatchDetails({ mainApi: shipmentApi.mainApi, logger: state.logger })
  const batchItems = flatten(Object.values(funderShipments))
    .filter(row => row.manufacturer && row.batchno && row.expiry)
    .map(row => ({
      skuCode: row.product,
      batchNo: row.batchno,
      manufacturer: row.manufacturer,
      expiry: new Date(row.expiry).toJSON()
    }))
  await bulkUpsertBatchDetails(batchItems)

  const allSnapshots = []
  for (const shipment of Object.values(funderShipments)) {
    const snapshots = await bulkSnapshotsFromCsv(state, shipment, shipmentApi)
    const processedSnapshots = await Promise.all(
      snapshots.map(async (snapshot) => {
        if (!snapshot.otpKey) {
          const shipmentId = docIdToShipmentId(snapshot.id)
          const otpCode = await shipmentApi.otp.pg.getPassword(shipmentId)
          if (!otpCode && crypto) {
            const snapshotId = snapshot.id
            const { password, key } = await shipmentApi.otp.generate(crypto)
            const otpDoc = await shipmentApi.otp.couch.createKeySnapshot(snapshotId, key)
            await shipmentApi.otp.pg.setPassword(shipmentId, password, otpDoc.id, key)
          }
        }
        return snapshot
      })
    )

    let updatedSnapshots = []
    // TODO: move to config
    const assumedProgramIdForAllShipments = get(processedSnapshots, '0.programId')
    if (!PROGRAMS_NEEDING_TMS_AUTO_ROUTER.includes(assumedProgramIdForAllShipments)) {
      updatedSnapshots = await shipmentApi.bulkAdvanceSnapshots({ shipments: processedSnapshots })
    } else {
      updatedSnapshots = processedSnapshots
    }
    allSnapshots.push(...updatedSnapshots) // ?
  }
  return allSnapshots
}
